import React from "react";
import Modal from "react-bootstrap/Modal";
import "./popalert.css";
import Button from "../ThemeButton/ThemeButton";
import PropTypes from "prop-types";
import SuccessPopupIcon from "../../assets/images/success-popup.svg";

const PopupAlert = ({
  show,
  setShow,
  alertMessage,
  handleSubmit = () => setShow(false),
}) => {
  return (
    <div>
      <Modal show={show} className="alertBoxModal popupAlert popSuccessAlert">
        <div className="contentContainerConfirmAlert">
          <Modal.Header closeButton>
            <div className="imgTitles">
              <img src={SuccessPopupIcon} alt="icon" />
            </div>
            <Modal.Title>Success</Modal.Title>
            <div className="modalBody">{alertMessage}</div>
          </Modal.Header>
          <Modal.Footer>
            <div className="btnSuccessAlert">
              <Button value="Close" onClick={handleSubmit}></Button>
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  );
};

PopupAlert.proptype = {
  setShow: PropTypes.func,
  show: PropTypes.bool,
  title: PropTypes.string,
  alertMessage: PropTypes.string,
  buttonSubmitText: PropTypes.string,
};
export default PopupAlert;
